<template>
	<div id="dorm_index">
		<dv-full-screen-container class="bg">
			<dv-loading v-if="loading">Loading...</dv-loading>
			<div v-else class="host-body">
				<!-- 全屏 -->
				<div v-on:click="screen()" v-if="showFlag"><dv-decoration-9 :color="['#55ffff', '#0090ff']" class="full_screen">{{ screenName }}</dv-decoration-9></div>
				<!-- 标题-->
				<div class="d-flex jc-center dorm_titbg">
					<div class="dorm_tit">{{ title }}</div>
					<dv-decoration-2 :color="['#00ffff', '#0090ff']"
						style="width:3rem;height:5px;position: absolute;left:22%;top: 0.02rem" />
					<dv-decoration-10 :reverse="true" :color="['#00ffff', '#0090ff']"
						style="width:2.5rem;height:5px;position: absolute;right:23%;top: 0.03rem" />
					<!-- 时间和天气 -->
					<div class="time_weather">
						<div class="float-r">{{ date }}</div>
					</div>
				</div>

				<div class="body-box">
					<!-- 第四行数据开始 -->
					<div class="w-100 content-box">
						<div class="main_grid">
							<!-- 第一列 -->
							<div class="left_block">
								<left />
							</div>
							<!-- 第一列结束 -->
							<!-- 第二列 -->
							<div>
								<!-- 上半部分 -->
								<!-- 中间3小块数据 -->
								<div class="cc-header">
									<div class="title_circle"></div>
									宿舍楼实时监控状态
								</div>
								<div class="top">
									<top />
								</div>
								<!-- 滚动区域开始 -->
								<div class="mc_block">
									<scrollcenter />
								</div>
								<!-- 滚动区域结束 -->
								<!-- 中间底部开始 -->
								<div class="mb_block">
									<!-- 左边 -->
									<div class="b_block01">
										<bottom1 />
									</div>
									<!-- 右边 -->
									<div class="b_block01">
										<bottom2 />
									</div>
								</div>
								<!-- 中间底部结束 -->

							</div>
							<!-- 第二列结束 -->
							<!-- 第三列开始 -->
							<div style="padding-left:3.5%">
								<div class="cc-header">
									<div class="title_circle"></div>
									未归宿名单
								</div>
								<!-- 1 -->
								<div class="r_block01">
									<right1 />
								</div>
								<!-- 2 -->
								<div class="r_block02">
									<right2 />
								</div>
							</div>
							<!-- 第三列结束 -->
						</div>
					</div>
					<!-- 第四行数据结束 -->
				</div>

			</div>
		</dv-full-screen-container>
	</div>
</template>

<script>
var storage = window.localStorage;
var orgCode = storage.getItem("orgCode");
var source = storage.getItem("source");
var schoolName = storage.getItem("schoolName");
var title = storage.getItem("title");
if (title == 'false') {
	title = schoolName + '智慧宿舍大数据看板';
}

import left from "./left";
import top from "./top";
import right1 from "./right1";
import right2 from "./right2";
import scrollcenter from "./scrollcenter";
import bottom1 from "./bottom1";
import bottom2 from "./bottom2";
export default {
	data() {
		return {
			loading: true,
			title: title,
			showFlag: true,
			date: this.dateFormatToString(new Date()),
			fullscreen: false,
			screenName: "全屏"
		};
	},
	components: {
		left,
		top,
		right1,
		right2,
		scrollcenter,
		bottom1,
		bottom2
	},
	mounted() {
		this.cancelLoading();
		this.initData();
		// 定时刷新时间
		let _this = this;
		// 定时器
		this.interval1 = setInterval(() => {
			_this.date = _this.dateFormatToString(new Date()); // 修改数据date
		}, 1000);
		// 定时器刷新，1天
		this.interval2 = setInterval(() => {
			_this.initData();
		}, 1000 * 60 * 60 * 24);
	},
	methods: {
		//关闭loading加载条
		cancelLoading() {
			setTimeout(() => {
				this.loading = false;
			}, 1000);
		},
		initData() {
			let _this = this;
			//判断访问客户端类型
			if (source == 'window') {
				_this.screenName = "全屏";
				_this.showFlag = true;
			} else {
				var type = _this.$route.query.type;
				if(type == 'build'){
					_this.showFlag = false;
					_this.screenName = "";
				}else{
					_this.showFlag = true;
					_this.screenName = "返回";
				}
			}
		},
		//日期格式化
		dateFormatToString(data) {
			let formatDateTime
			let Y = data.getFullYear()
			let M = data.getMonth() + 1
			let D = data.getDate()
			let H = data.getHours()
			let Min = data.getMinutes()
			let S = data.getSeconds()
			let W = data.getDay()
			H = H < 10 ? ('0' + H) : H
			Min = Min < 10 ? ('0' + Min) : Min
			S = S < 10 ? ('0' + S) : S
			switch (W) {
				case 0:
					W = '天'
					break
				case 1:
					W = '一'
					break
				case 2:
					W = '二'
					break
				case 3:
					W = '三'
					break
				case 4:
					W = '四'
					break
				case 5:
					W = '五'
					break
				case 6:
					W = '六'
					break
				default:
					break
			}
			formatDateTime = Y + '年' + M + '月' + D + '日 ' + H + ':' + Min + ':' + S + ' 星期' + W;
			this.date = formatDateTime;
			return formatDateTime
		},
		//点击全屏
		screen: function () {
			//判断访问客户端类型
			if (source == 'window') {
				let _this = this;
				let element = document.documentElement;
				if (_this.fullscreen) {
					if (document.exitFullscreen) {
						document.exitFullscreen();
					} else if (document.webkitCancelFullScreen) {
						document.webkitCancelFullScreen();
					} else if (document.mozCancelFullScreen) {
						document.mozCancelFullScreen();
					} else if (document.msExitFullscreen) {
						document.msExitFullscreen();
					}
					_this.screenName = "全屏";
				} else {
					if (element.requestFullscreen) {
						element.requestFullscreen();
					} else if (element.webkitRequestFullScreen) {
						element.webkitRequestFullScreen();
					} else if (element.mozRequestFullScreen) {
						element.mozRequestFullScreen();
					} else if (element.msRequestFullscreen) {
						element.msRequestFullscreen();
					}
					_this.screenName = "取消";
				}
				_this.fullscreen = !_this.fullscreen;
			} else {
				var type = this.$route.query.type;
				if(type != 'build'){
					//window.AndroidWebView.finish();
					this.$router.replace('/dataView/appIndex/school?orgCode=' + orgCode);
				}
			}
		}
	},
	beforeDestroy() {
		clearInterval(this.interval1);
		clearInterval(this.interval2);
	}
};
</script>

<style lang="scss">
@import "../../assets/scss/dormIndex.scss";

#dorm_index {

	.left_block {
		height: 80vh;
		position: relative;
		width: 100%;
		height: 100%;
	}

	// 标题
	.cc-header {
		width: 100%;
		color: #00f0ff;
		font-size: 0.25rem;
		font-weight: bold;
		display: flex;
		position: relative;
		align-items: center;
		background-image: linear-gradient(to right, rgba(0, 102, 127, 0.6) 30%, rgba(0, 102, 127, 0) 70%);
		height: 0.5rem;
		padding-left: 0.2rem;
		border-radius: 10rem;

		.title_circle {
			width: 0.2rem;
			height: 0.2rem;
			align-items: center;
			background: #00c8da;
			display: inline-block;
			border-radius: 50%;
			margin-right: 0.1rem;
		}
	}

	@media screen and (min-width: 768px) and (max-width: 992px) {}

	@media screen and (min-width: 1200px) and (max-width: 1920px) {}

	// 标题结束

	.b_block01 {
		height: 31.5vh;

	}

	.r_block01 {
		height: 47.6vh;
	}

	.r_block02 {
		height: 31.4vh;
		margin-top: 0.3rem;
	}

	.mc_block {
		height: 36.3vh;
	}

	.mb_block {
		display: grid;
		grid-template-columns: 1fr 1fr;
		margin-top: 0.32rem;
	}
}
</style>
